import { render, staticRenderFns } from "./ApiPermissions.vue?vue&type=template&id=ad583e74"
import script from "./ApiPermissions.vue?vue&type=script&lang=js"
export * from "./ApiPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports